import { render, staticRenderFns } from "./MitAdminMonitorPage.vue?vue&type=template&id=2bb83088&scoped=true"
import script from "./MitAdminMonitorPage.vue?vue&type=script&lang=js"
export * from "./MitAdminMonitorPage.vue?vue&type=script&lang=js"
import style0 from "./MitAdminMonitorPage.vue?vue&type=style&index=0&id=2bb83088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb83088",
  null
  
)

export default component.exports